import _defineProperty from "/var/jenkins_home/workspace/web_bieyangapp_review_page/product-search/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import classNames from 'classnames';
import React from 'react';
import { withNativeProps } from '../../utils/native-props';
import { useShouldRender } from '../../utils/should-render';
import { DownFill } from 'antd-mobile-icons';
var classPrefix = "adm-dropdown-item";

var Item = function Item(props) {
  var _classNames;

  var _a;

  var cls = classNames(classPrefix, (_classNames = {}, _defineProperty(_classNames, "".concat(classPrefix, "-active"), props.active), _defineProperty(_classNames, "".concat(classPrefix, "-highlight"), (_a = props.highlight) !== null && _a !== void 0 ? _a : props.active), _classNames));
  return withNativeProps(props, React.createElement("div", {
    className: cls,
    onClick: props.onClick
  }, React.createElement("div", {
    className: "".concat(classPrefix, "-title")
  }, React.createElement("span", {
    className: "".concat(classPrefix, "-title-text")
  }, props.title), React.createElement("span", {
    className: classNames("".concat(classPrefix, "-title-arrow"), _defineProperty({}, "".concat(classPrefix, "-title-arrow-active"), props.active))
  }, props.arrow === undefined ? React.createElement(DownFill, null) : props.arrow))));
};

export default Item;
export var ItemChildrenWrap = function ItemChildrenWrap(props) {
  var _props$active = props.active,
      active = _props$active === void 0 ? false : _props$active;
  var shouldRender = useShouldRender(active, props.forceRender, props.destroyOnClose);
  var cls = classNames("".concat(classPrefix, "-content"), _defineProperty({}, "".concat(classPrefix, "-content-hidden"), !active));
  return shouldRender ? React.createElement("div", {
    className: cls,
    onClick: props.onClick
  }, props.children) : null;
};